import { render } from "./icons-whatsapp.svg?vue&type=template&id=2e02b2f8?inline"
const script = {}
script.render = render

export default script